<template>
  <div class="btn-pay-wrapper">
    <div
      class="btn-pay"
      :class="{ disabled: !isAgree }"
      @click="$emit('click')"
    >
      <div class="price-info">
        <div class="tip">{{ config.tip }}</div>
        <div class="del-price">{{ config.del_price }}</div>
      </div>
      <div class="price">
        <img :src="config.price_image" alt />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ButtonV1 extends Vue {
  @Prop({ type: Object, default: () => ({}) }) config!: any;
  @Prop({ type: Boolean, default: true }) isAgree!: boolean;
}
</script>

<style lang="scss" scoped>
@import '@style/helps.scss';
.btn-pay {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 14px 0 16px;
  color: #fff;
  background: linear-gradient(259deg, #fdc538, #fd9246);
  border-radius: 12px;
  @include forbid-select;
  .price-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    .tip {
      font-weight: 600;
      font-size: 40px;
      letter-spacing: 0.76px;
      white-space: nowrap;
    }
    .del-price {
      position: relative;
      margin-top: 5px;
      font-weight: 600;
      font-size: 20px;
      letter-spacing: 0.38px;
      &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 105%;
        height: 4px;
        background: #fff;
        transform: translate(-50%, -50%) rotate(-6deg);
        content: '';
      }
    }
  }
  .price {
    display: flex;
    align-items: flex-end;
    &::after {
      font-weight: 500;
      font-size: 24px;
      transform: translate(0, -6px);
      content: '元';
    }
    img {
      width: 132px;
      height: 90px;
    }
  }
  &:active:not(.disabled) {
    opacity: 0.7;
  }
  &.disabled {
    opacity: 0.3;
  }
}
.btn-pay-wrapper {
  width: 311px;
  height: 116px;
  background: #fff;
  border-radius: 12px;
}
</style>